import styles from './ActionBar.module.scss';
import { ContactButton } from '@/components/_shared/buttons/ContactButton/ContactButton';
import { FollowButton } from '@/components/_shared/buttons/FollowButton/FollowButton';
import type { OrganizerWithFollowStatus } from '@/components/OrganizerCard/types';

export type ActionBarProps = {
  organizer: OrganizerWithFollowStatus;
  pageArea?: string;
};

export const ActionBar = ({ organizer, pageArea }: ActionBarProps) => {
  return (
    <div className={styles.actionBar}>
      <ContactButton organizerId={organizer.id} organizerName={organizer.name} />
      <FollowButton organizer={organizer} pageArea={pageArea} />
    </div>
  );
};
